<template>
	<div id="edit-applicant">
		<form-apply v-if="applicantRec"
			v-on:save-applicant = "saveApplicant"
			v-bind:isLoading = "isLoading"
			v-bind:applicant = "applicantRec"
			crud = "edit"
			title = "Edit Applicant"
			icon = "fa-user-edit"
			isPrivate
		>
		</form-apply>
	</div>
</template>
<script>
import FormApply from '@/components/FormApply.vue'
export default {
	components: { FormApply },
	data() {
		return {
			isLoading: false,
			recId: this.$route.params.id
		}
	},
	computed: {
		applicantRec(){
			return this.$store.getters.applicantProfile(this.$route.params.id)
		}
	},
	methods: {
		async loadApplicant(id) {
			if(this.applicantRec === undefined){
				this.isLoading = true
				await this.$store.dispatch('loadApplicant',id)
				this.isLoading = false
			}
		},
		async saveApplicant(data){
			this.isLoading = true
			data.id = this.recId
			await this.$store.dispatch('editApplicant',data)
			setTimeout(() => { 
				this.isLoading = false 
				this.$router.replace({ name: 'Applicants'})
			},333);

		}
	},
	created() {
		this.loadApplicant(this.$route.params.id)
	}
}
</script>